import React from 'react';
import { NavLink  } from "react-router-dom";

import HeroSection from '../sections/HeroSection/HeroSection';
import BasicSection from '../sections/BasicSection/BasicSection';
import MultiInfoSection from '../sections/MultiInfoSection/MultiInfoSection';
import MoreDescriptionSection from '../sections/MoreDescriptionSection/MoreDescriptionSection';
import AdvencedSection from '../sections/AdvencedSection/AdvencedSection';
import DescriptionSection from '../sections/DescriptionSection/DescriptionSection';
import AddressAllegroSection from '../sections/AddressAllegroSection/AddressAllegroSection';

const Poligrafia = () => (
    <React.Fragment>
        <HeroSection image="./assets/poligrafia_banner.jpg"/>
        <BasicSection
            id="poligrafia"
            title="poligrafia"
            image="./assets/big_poligrafia.png"
            theme="darkblue"
            rightColumn={
                <p>
                 Realizujemy zamówienia na materiały poligraficzne,
                 nie tylko drukujemy, ale również projektujemy jako pojedyncze
                 elementy lub części większego projektu. Zajmujemy się obróbką
                 poligraficzną kompleksowo: przygotowaniem projektu, opracowaniem
                 tekstu i grafiki, drukiem i oczywiście wykończeniem i uszlachetnieniem
                 wydrukowanych materiałów. Drukujemy foldery, katalogi, cenniki,
                 publikacje, listowniki (akcydensy firmowe), wizytówki, teczki, etykiety…
                </p>
            }
        />
        <BasicSection
            id="etykiety"
            title="etykiety"
            image="./assets/big_etykiety.png"
            theme="blue"
            leftColumn={
                <p>
                  Drukujemy etykiety już od jednej sztuki – realizujemy wszelkie
                  zamówienia, nie ograniczając się jedynie do tych, które zakładają
                  ogromne nakłady. To ważny element naszej filozofii, by do każdego
                  Klienta i każdego zamówienia podejść indywidualnie i zaproponować
                  najodpowiedniejsze rozwiązanie. By jak najlepiej zrealizować temat,
                  wybierzemy odpowiedni materiał - papier, papier ozdobny, folię – oraz
                  dobierzemy właściwe wykończenie – uszlachetnianie wydruku, błysk, mat.
                  Kształt nas nie ogranicza: nasze etykiety mogą być kwadratowe, okrągłe
                  lub nieregularne.
                </p>
            }
        />
        <MultiInfoSection
            items={[
                {img: './assets/naklejka_1_sztuka.png', text: 'wydruk od 1 sztuki'},
                {img: './assets/naklejka_dowolny_ksztalt.png', text: 'dowolny kształt'},
                {img: './assets/naklejka_mozliwosc_personalizacji.png', text: 'możliwość personalizacji'},
                {img: './assets/naklejka_uszlachetnianie_wydruku.png', text: 'uszlachetnianie wydruku'}
            ]}
        />
        <AdvencedSection
            id="wydruk-etykiet"
            title="wydruk etykiet"
            theme="darkblue"
            items={[
                {title: 'na arkuszach', image: './assets/naklejka_na_arkuszach.png', link: '/arkusz'},
                {title: 'na rolce', image: './assets/naklejka_na_rolce.png', link: '/rolka'}
            ]}
        />
        <MoreDescriptionSection
            img="./assets/naklejka_karton.png"
            text={
                <div>
                    Istnieje możliwość wydruku próbnego<br/>- dzięki któremu przetestują Państwo jakość druku oraz kleju.<br/>
                    <b>Zamów wydruk próbny: <a href="tel:509-631-155">+48 509 631 155</a>, <a href="mailto:biuro@printlabel.pl">biuro@printlabel.pl</a></b>
                </div>
            }
        />
        <BasicSection
            title="opakowania fasonowe"
            image="./assets/big_opakowania.png"
            theme="blue"
            rightColumn={
                <p>
                  Dostępne w różnych wymiarach i grubościach mogą stanowić element eleganckiego
                  wykończenia produktu lub po prostu skutecznie ochraniać produkt w czasie transportu.
                  Dla każdego zamówienia wykonamy indywidualny projekt, uwzględniając specyfikę produktu,
                  przeznaczenie opakowania oraz charakter odbiorcy. Robimy wykroje fasonowe, realizujemy
                  zamówienia na pudełka kaszerowane, pudełka z kartonów litych oraz materiały POS: standy,
                  ekspozytory i displaye.
                </p>
            }
        />
        <DescriptionSection
            imageButton="./assets/mouse-link.png"
            imageLink="/studio"
        >
            <React.Fragment>
                <h4>
                    Masz produkt<br />
                    ale nie masz projektu?
                </h4>
                <h4>
                    Świetnie trafiłeś!<br />
                    Zapraszamy do <b><NavLink to="/studio">studia graficznego</NavLink>.</b>
                </h4>
            </React.Fragment>
        </DescriptionSection>
        <AddressAllegroSection />
    </React.Fragment>
);

export default Poligrafia;